<template>
  <div>
    <AppSidebar />
    <div class="wrapper d-flex flex-column min-vh-100 bg-light"
         @mouseup="$store.commit('updateSidebar','2')"
         @mouseover="$store.commit('updateSidebar','2')">
      <AppHeader />
      <div class="body flex-grow-1 px-2" style="padding-top: 73px;">
<!--        <CContainer lg>-->
          <router-view :key="$route.fullPath"/>
<!--        </CContainer>-->
      </div>
      <AppFooter />
    </div>
  </div>
</template>
<script>
// import { CContainer } from '@coreui/vue'
import AppFooter from '@/components/AppFooter.vue'
import AppHeader from '@/components/AppHeader.vue'
import AppSidebar from '@/components/AppSidebar2.vue'

export default {
  name: 'DefaultLayout',
  components: {
    AppFooter,
    AppHeader,
    AppSidebar,
    // CContainer,
  },
}
</script>
